import React, { useEffect, useState } from 'react';
import './EnergyModal.css';
import closeIcon from '../assets/icons/closeIcons.webp';
import staminaIcon from '../assets/icons/stamina.webp';
import farmIcon from '../assets/icons/farm.webp';
import plusIcon from '../assets/icons/plusIcons.webp';
import negativeIcon from '../assets/icons/negativeIcons.webp';
import { actAddButton } from '../api/waxApi';
import SEASONS from '../config/seasons';

function EnergyModalContent({
  onClose,
  wallet,
  refreshStamina,
  setLogLines,
  setLogModalOpen,
  setErrorModalOpen,
  setErrorMessage,
  balances,
  stamina,
  seasonId
}) {
  const [amount, setAmount] = useState(0);
  const [inputValue, setInputValue] = useState("0"); // input'ta görünen
  const [loading, setLoading] = useState(false);
  const [exceedsStamina, setExceedsStamina] = useState(false);
  const [exceedsFarm, setExceedsFarm] = useState(false);


  const parseBalance = (symbol) => {
    const list = Array.isArray(balances) ? balances : Object.values(balances || {});
    const entry = list.find((b) => typeof b === 'string' && b.endsWith(` ${symbol}`));
    return entry ? parseFloat(entry.split(' ')[0]) : 0;
  };

  const farmBalance = parseBalance('FARM');
  //const requiredFarm = amount / 5;
  const currentSeason = SEASONS.find(s => s.id === seasonId);
  const seasonStaminaCost = currentSeason?.stamina_cost || 20; // fallback değeri yaz
  const requiredFarm = (amount * seasonStaminaCost) / 100;

  useEffect(() => {
    setAmount(0);
  }, []);

  useEffect(() => {
    setExceedsStamina(stamina.first + amount > stamina.second);
    setExceedsFarm(requiredFarm > farmBalance);
  }, [amount, stamina, farmBalance, requiredFarm]);

  const handleExchange = async () => {
    if (amount <= 0 || exceedsStamina || exceedsFarm || loading) return;
    setLoading(true);

    const viewer = localStorage.getItem("loggedInUser");
    const target = wallet;
    if (!viewer || !target) {
      setLoading(false);
      return;
    }

    const tx = await actAddButton(target, amount);
    if (tx?.error) {
      setErrorMessage(tx.error);
      setErrorModalOpen(true);
      setLoading(false);
      return;
    }

    if (tx?.log) {
      setLogLines(Array.isArray(tx.log) ? tx.log : [tx.log]);
      setLogModalOpen(true);
    }

    if (refreshStamina) await refreshStamina();
    setLoading(false);
    onClose();
  };

  const handleInputChange = (e) => {
    let input = e.target.value;

    // Eğer input boşsa 0 göster
    if (input === "") {
      setInputValue("0");
      setAmount(0);
      return;
    }

    // Eğer sadece 0'lardan oluşuyorsa, en fazla bir tane 0 bırak
    if (/^0+$/.test(input)) {
      setInputValue("0");
      setAmount(0);
      return;
    }

    // Sayı değilse iptal
    if (!/^\d+$/.test(input)) return;

    // Baştaki sıfırları sil
    input = input.replace(/^0+/, '');
    const val = parseInt(input);

    const maxVal = Math.min(
      stamina.second - stamina.first,
      Math.floor(farmBalance * 5)
    );

    const safeVal = !isNaN(val) ? Math.min(maxVal, val) : 0;
    setAmount(safeVal);
    setInputValue(String(safeVal));
  };

  return (
    <div className="modall-overlay" onClick={onClose}>
      <div className="modall-panel energy-modall" onClick={(e) => e.stopPropagation()}>
        <img src={closeIcon} className="modall-close" onClick={onClose} alt="close" />
        <img src={staminaIcon} className="modall-icon" alt="stamina" />

        <div className="menu-counter">
          <img
            src={negativeIcon}
            alt="decrease"
            className="counter-img"
            onClick={() =>
              setAmount((a) => {
                const next = Math.max(0, a - 1);
                setInputValue(String(next));
                return next;
              })
            }
          />
          <input
            className="counter-input"
            type="number"
            min="0"
            value={inputValue}
            onChange={handleInputChange}
          />

          <img
            src={plusIcon}
            alt="increase"
            className="counter-img"
            onClick={() =>
              setAmount((a) => {
                const next = Math.min(
                  a + 1,
                  stamina.second - stamina.first,
                  Math.floor(farmBalance * 5)
                );
                setInputValue(String(next));
                return next;
              })
            }
          />
        </div>

        <button
          className="menu-energy-btn"
          disabled={amount === 0 || loading || exceedsStamina || exceedsFarm}
          onClick={handleExchange}
        >
          {loading ? 'Processing...' : 'Exchange'}
        </button>

        <div className="energy-rate">
          <div className="rate-row">
            <img src={staminaIcon} className="rate-icon" alt="stamina" />
            <span className="rate-text">1 STAMINA = {(seasonStaminaCost / 100).toFixed(4)} FARM</span>
            <img src={farmIcon} className="rate-icon" alt="farm" />
          </div>
          <div className="rate-row">
            <img src={farmIcon} className="rate-icon" alt="farm" />
            <span className="rate-text">{requiredFarm.toFixed(4)} FARM = {amount} STAMINA</span>
            <img src={staminaIcon} className="rate-icon" alt="stamina" />
          </div>
        </div>

        {(exceedsStamina || exceedsFarm) && (
          <div className="warning-container">
            {exceedsStamina && <div className="warning-text">Maximum stamina limit!</div>}
            {exceedsFarm && <div className="warning-text">Not enough FARM tokens.</div>}
          </div>
        )}
      </div>
    </div>
  );
}

export default function EnergyModal(props) {
  return <EnergyModalContent {...props} />;
}
